import ChangePassword from './page/CreateNewPassword/ChangePassword'
import ForgotPassword from './page/ForgotPassword/ForgotPassword'
import LoginEmail from './page/LoginEmail/LoginEmail'

const AuthScreens = {
  LOGIN_EMAIL: {
    COMPONENT: LoginEmail,
    PATH: '/auth/login-email',
  },
  FORGOT: {
    COMPONENT: ForgotPassword,
    PATH: '/auth/forgot-password',
  },
  CHANGE_PASSWORD: {
    COMPONENT: ChangePassword,
    PATH: '/auth/change-password',
  },
}

export default AuthScreens
